import { render } from "./ChangePassDialog.vue?vue&type=template&id=c14633fe&scoped=true"
import script from "./ChangePassDialog.vue?vue&type=script&lang=js"
export * from "./ChangePassDialog.vue?vue&type=script&lang=js"

import "./ChangePassDialog.vue?vue&type=style&index=0&id=c14633fe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c14633fe"]])

export default __exports__